export class ThumbnailUtils {
  static b64toByteArrays = (b64Data: string): Uint8Array => {
    const byteCharacters = atob(
      b64Data.replace(
        /^data:image\/(png|jpeg|jpg|webp|tiff|tif|bmp|gif|ico|svg);base64,/,
        ''
      )
    );

    const byteArrays = Uint8Array.from(byteCharacters, (c) => c.charCodeAt(0));

    return byteArrays;
  };

  static b64toFile = (b64Data: string, thumbnailFileName: string): File => {
    const contentType = 'image/jpeg';

    const byteArrays = ThumbnailUtils.b64toByteArrays(b64Data);

    const n = byteArrays.length;
    const newByteArrays = new Uint8Array(n);
    for (let i = 0; i < n; i++) {
      newByteArrays[i] = byteArrays[i];
    }

    const newFile = new File([newByteArrays], thumbnailFileName, {
      type: contentType,
      lastModified: Date.now(),
    });

    return newFile;
  };

  static compressAndResizeImage(image) {
    const qualityDecimal = 20 / 100;
    const width = 256;
    const height = 256;
    const canvas = document.createElement('canvas');
    canvas.width = width;
    canvas.height = height;
    canvas.style.visibility = 'hidden';

    const ctx = canvas.getContext('2d');
    ctx.fillStyle = 'rgba(0, 0, 0, 0)';
    ctx.fillRect(0, 0, width, height);

    if (ctx.imageSmoothingEnabled && ctx.imageSmoothingQuality) {
      ctx.imageSmoothingQuality = 'high';
    }

    ctx.drawImage(image, 0, 0, width, height);

    return canvas.toDataURL('image/jpeg', qualityDecimal);
  }
}
